const canvas = document.querySelector('#spring-text'),
    ctx = canvas.getContext('2d'),
    mouse = {x: 0, y: 0};

let particles = [],
    amount = 0,
    radius = 1;

const colors = ['#fff', '#f0f8ff', '#dad0ef'];

const copy = document.querySelector('#copy');

let ww = (canvas.width = window.innerWidth);
let wh = (canvas.height = window.innerHeight);

function Particle(x, y) {
    this.x = Math.random() * ww;
    this.y = Math.random() * wh;
    this.dest = {
        x: x,
        y: y
    };
    this.r = Math.random() * 1 + 2;
    this.vx = (Math.random() - 0.5) * 20;
    this.vy = (Math.random() - 0.5) * 20;
    this.accX = 0;
    this.accY = 0;
    this.friction = Math.random() * 0.02 + 0.94;

    this.color = colors[Math.floor(Math.random() * 6)];
}

Particle.prototype.render = function() {
    this.accX = (this.dest.x - this.x) / 1000;
    this.accY = (this.dest.y - this.y) / 1000;
    this.vx += this.accX;
    this.vy += this.accY;
    this.vx *= this.friction;
    this.vy *= this.friction;

    this.x += this.vx;
    this.y += this.vy;

    ctx.fillStyle = this.color;
    ctx.beginPath();
    ctx.arc(this.x, this.y, this.r, Math.PI * 2, false);
    ctx.fill();

    const a = this.x - mouse.x;
    const b = this.y - mouse.y;

    const distance = Math.sqrt(a * a + b * b);
    if (distance < radius * 30) {
        this.accX = (this.x - mouse.x) / 100;
        this.accY = (this.y - mouse.y) / 100;
        this.vx += this.accX;
        this.vy += this.accY;
    }
};

function onMouseMove(e) {
    mouse.x = e.clientX;
    mouse.y = e.clientY;
}

function onTouchMove(e) {
    if (e.touches.length > 0) {
        mouse.x = e.touches[0].clientX;
        mouse.y = e.touches[0].clientY;
    }
}

function onTouchEnd(e) {
    e;
    mouse.x = -9999;
    mouse.y = -9999;
}

function initScene() {
    ww = canvas.width = window.innerWidth;
    wh = canvas.height = window.innerHeight;

    // console.log({ww, wh});

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    const fontSize = ww / 13;

    ctx.font = 'bold ' + fontSize + 'px "Arial", "DIN Pro", sans-serif';
    ctx.textAlign = 'center';

    // const headerArray = copy.value.split(' ');
    /*
    // let y = canvas.height / 2;
    ctx.fillText(headerArray[0], ww / 2, wh / 2);
    for (let i = 0; i < headerArray.length; i++) {
        // ctx.fillText(copy.value, ww / 2, wh / 2);
        // ctx.fillText(headerArray[i], ww / 2, wh / 2);
        // y += ww / 10;
    }*/
    const textOne = 'Мобилизация';
    const textTwo = 'встроенной';
    const textThree = 'защиты';
    ctx.fillText(textOne, ww / 2, wh / 3.3);
    ctx.fillText(textTwo, ww / 2, wh / 3.3 + fontSize * 0.8);
    ctx.fillText(textThree, ww / 2, wh / 3.3 + fontSize * 0.8 * 2);

    const data = ctx.getImageData(0, 0, ww, wh).data;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.globalCompositeOperation = 'screen';

    particles = [];
    for (let i = 0; i < ww; i += Math.round(ww / 210)) {
        for (let j = 0; j < wh; j += Math.round(ww / 210)) {
            if (data[(i + j * ww) * 4 + 3] > 210) {
                particles.push(new Particle(i, j));
            }
        }
    }
    amount = particles.length;
}

function onMouseClick() {
    radius++;
    if (radius === 2) {
        radius = 0;
    }
}

function render(a) {
    a;
    requestAnimationFrame(render);
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    for (let i = 0; i < amount; i++) {
        particles[i].render();
    }
}

let inited = false;

const mainpageHeaderAnimation = (function() {
    function init() {
        inited = true;
        copy.addEventListener('keyup', initScene);
        window.addEventListener('resize', initScene);
        window.addEventListener('mousemove', onMouseMove);
        window.addEventListener('touchmove', onTouchMove);
        window.addEventListener('click', onMouseClick);
        window.addEventListener('touchend', onTouchEnd);
        initScene();
        requestAnimationFrame(render);
        /*
        resizeCanvas();
        adjustText();
        window.requestAnimationFrame(animate);
        */
    }
    function destroy() {
        if (inited) {
            inited = false;
            copy.removeEventListener('keyup', initScene);
            window.removeEventListener('resize', initScene);
            window.removeEventListener('mousemove', onMouseMove);
            window.removeEventListener('touchmove', onTouchMove);
            window.removeEventListener('click', onMouseClick);
            window.removeEventListener('touchend', onTouchEnd);
        }
    }
    return {
        init: init,
        destroy: destroy
    };
})();
export default mainpageHeaderAnimation;
